import { createElement } from '@wordpress/element'
import ReactDom from 'react-dom'

import * as youtube from './acf-blocks/youtubeVideo.jsx';
import * as careerItemsSlider from './acf-blocks/CareerItemsSlider.jsx';
import * as mobileMenu from './acf-blocks/mobileMenu.js';

function initWithComponent(elem, Component) {
  const dataElement = elem.previousElementSibling;
  let data = {};
  if (dataElement.tagName === 'SCRIPT' && dataElement.type === "application/json") {
    data = JSON.parse(dataElement.innerText);
    dataElement.parentElement.removeChild(dataElement);
  }

  Component && ReactDom.hydrate(createElement(Component, data), elem);
}


export function init() {
  [
    youtube,
    careerItemsSlider,
    mobileMenu
  ].forEach(({ selector, Component, init }) => {
    Component && document.querySelectorAll(selector).forEach(e => initWithComponent(e, Component));
    init && init();
  })
}
